import { styled } from "@mui/material/styles";
import {
  DetailedHTMLProps,
  FC,
  InputHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

const Input: FC<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = (props) => <input {...props} />;

export const BootstrapInput = styled(Input)(({ theme }) => {
  // console.log("BootstrapInput", { theme });

  return {
    "&": {
      height: 56,
      outline: "none",
      caretColor: "#ff2800",
      borderRadius: 56,
      position: "relative",
      backgroundColor: "#f5f7fa",
      border: "1px solid #ced4da",
      fontSize: 14,
      padding: "20px 24px",
      borderColor: "transparent",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus,&:not([disabled]):hover": {
        borderColor: "#ff2800",
        color: "#18191C",
        backgroundColor: "#FFF",
      },
      "&::placeholder": {
        color: "#AFC0D5",
      },
    },
  };
});

const Textarea: FC<
  DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >
> = (props) => <textarea {...props} />;

export const BootstrapTextarea = styled(Textarea)(({ theme }) => {
  return {
    "&": {
      resize: "none",
      minWidth: 500,
      maxWidth: 500,
      minHeight: 128,
      maxHeight: 128,
      lineHeight: "22px",
      outline: "none",
      caretColor: "#ff2800",
      borderRadius: 28,
      position: "relative",
      backgroundColor: "#f5f7fa",
      border: "1px solid #ced4da",
      fontSize: 14,
      padding: "20px 24px",
      borderColor: "transparent",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus,&:hover": {
        borderColor: "#ff2800",
        color: "#18191C",
        backgroundColor: "#FFF",
      },
      "&::-webkit-scrollbar": {
        display: "none",
      },
      "&::placeholder": {
        color: "#AFC0D5",
      },
    },
  };
});
